import {container, defaultFont} from "../../main";

const updateStyle = theme => ({
    containerWithSidebar: {
        [theme.breakpoints.up("md")]: {
            marginLeft: "240px",
        }
    },
    container: {
        ...container,
        ...defaultFont
    },
    card: {
        minHeight: window.innerHeight * 0.94
    },
    cardHeader: {
        minHeight: "68px"
    },
    mainActionsContainer: {
        marginTop: "16px",
        textAlign: "right"
    },
    fieldContainer: {
        display: "flex",
        width: "40%",
        justifyContent: "space-between"
    },
    beatLoader: {
        position: "absolute",
        right: "18px",
        margin: "0 auto",
        top: "35px",
        display: "flex",
        justifyContent: "center"
    }
});

export default updateStyle;
